import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import Footer from '../../components/Layout/Footer';
import { fetchHomeContent } from '../../services/homeContentApi';
import { ADMIN_PORTAL_BASE } from '../../components/Layout/Header/portal';

const References = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 300);
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchHomeContent()
      .then((data) => {
        if (cancelled) return;
        const items = Array.isArray(data?.references)
          ? data.references
          : Array.isArray(data?.reference_logos)
            ? data.reference_logos
            : [];
        setLogos(items.filter((item) => item?.image && item?.name));
      })
      .catch(() => {
        if (!cancelled) setLogos([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <React.Fragment>
      <Header
        navImg={navImg1}
        parentMenu="References"
        activeMenu="/references"
      />
      <main className="references-page">
        <div className="container">
          <header className="references-intro">
            <h1>Références</h1>
            <p>Les organisateurs qui nous font <span>confiance.</span></p>
          </header>

          {loading ? (
            <p className="references-page__empty">Chargement des références…</p>
          ) : logos.length === 0 ? (
            <p className="references-page__empty">
              Les logos des organisateurs qui nous font confiance seront affichés ici.
            </p>
          ) : (
            <ul className="references-wall">
              {logos.map((logo) => (
                <li className="references-wall__item" key={`${logo.name}-${logo.image}`}>
                  <img src={logo.image} alt={logo.name} />
                </li>
              ))}
            </ul>
          )}
        </div>

        <section className="references-cta">
          <p className="references-cta__kicker"></p>
          <h2>
          Lancez-vous dès <span>maintenant</span> !
          </h2>
          <p>Rejoignez la communauté  Mboapass</p>
          <a
            className="references-cta__btn"
            href={`${ADMIN_PORTAL_BASE}/register`}
            rel="noopener noreferrer"
          >
            Créer une billeterie
          </a>
        </section>
      </main>
      <BackToTop scroll={isVisible} />
      <Footer />
    </React.Fragment>
  );
};

export default References;
